import useAwards from "@/hooks/useAwards";
import { AwardCard } from "@/ui/AwardCard";
import { Buttons } from "@/ui/Buttons";
import { Carousel } from "@/ui/Carousel";
import cn from "classnames";
import { Container } from "react-bootstrap";

import classes from "./styles.module.scss";

export default function ({
  className = "py-5 pb-md-6",
  title,
  description,
  buttons,
  prefix,
  winnersOnly = false,
  limit = 10,
  EditableText,
  EditableHtml,
  theme = "light",
}) {
  let awards = useAwards();

  if (winnersOnly) {
    awards = awards.filter((a) => /winner/i.test(a.title ?? ""));
  }

  // Most recent first, so the carousel opens on the current year and
  // scrolls back through previous years from there.
  awards = [...awards].sort((a, b) => (parseInt(b.year, 10) || 0) - (parseInt(a.year, 10) || 0));

  if (limit > 0) {
    awards = awards.slice(0, limit);
  }

  if (!awards.length) {
    return null;
  }

  return (
    <div className={cn(className, classes.AwardsCarousel)} data-bs-theme={theme}>
      <Container fluid="md" className="mw-xl text-center mb-5">
        <EditableText path="title" tag="h2">
          <span dangerouslySetInnerHTML={{ __html: title }} />
        </EditableText>
        <EditableHtml path="description">
          <span dangerouslySetInnerHTML={{ __html: description }} />
        </EditableHtml>
      </Container>
      <Carousel
        autoplay={true}
        elementKey={prefix}
        slidesPerView={1}
        breakpoints={{
          480: { slidesPerView: 1.4 },
          768: { slidesPerView: 2.2 },
          992: { slidesPerView: 3 },
          1200: { slidesPerView: 4 },
          1400: { slidesPerView: 5 },
        }}
        items={awards.map(({ id, name, title, image }) => (
          <AwardCard key={id} name={name} title={title} image={image} />
        ))}
      />
      <Buttons buttons={buttons} className="mt-5 justify-content-center" />
    </div>
  );
}
